import '../../../polyfills';

export function initSubmitOnChange(scope) {
    const scopePrefix = typeof scope === 'undefined' ? '' : scope + ' ';

    document.querySelectorAll(scopePrefix + '.submit-on-change__trigger').forEach((element) => {
        element.addEventListener('change', (event) => {
            submitAfterChange(event.target);
        });
    });
}

export function submitAfterChange(element) {
    let form = element.closest('.submit-on-change');

    if (form === null) {
        form = element.closest('form');
    }

    const submitButton = form.querySelector('.submit-on-change__target');

    // Mame urcene odesilaci tlacitko -klikneme na nej
    if (submitButton !== null) {
        submitButton.click();

        return;
    }

    // Mame urceno, ze form ma byt jako ajax
    if (form.classList.contains('submit-on-change--ajax')) {
        naja.uiHandler.submitForm(form);

        return;
    }

    form.submit();
}
